<script setup lang="ts"></script>

<template>
  <div class="flex min-w-0 flex-1 flex-col">
    <slot name="header" />
    <div class="flex min-w-0 flex-1 overflow-auto">
      <slot name="content" />
    </div>
    <slot name="footer" />
  </div>
</template>
